import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab3 = ({pageState, Company, WorkOrder, workOrderList, companyList, handleChange }) => {
  console.log(workOrderList, "workOrderList");

  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">More Information</p>
      </div>

      <div className="col-6 ">
        <div className='mb-3'>
          <SelectSearch
            list={companyList}
            label="Company"
            getOptionLabel={(item) =>
              item.isNew ? "+ Create New Company" : item.name
            }
            getOptionValue={(item) => item.name}
             value={pageState.company}
            onChange={(val) => handleChange('company', val)}
            createNewUrl="/master/company/create-Company"
            createNewLabel="Create New Company"
          />

        </div>
      </div>

      <div className="col-6">
        <div >
          <SelectSearch
            list={workOrderList || []}
            style={{
              height: "38px",
              border: WorkOrder?.Error ? "1px solid red" : "",
            }}
            label="Work Order"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={pageState.workOrder}
            onChange={(val) => handleChange('workOrder', val)}
          />
        </div>
      </div>
    </div>
  );
};

export default Tab3;